export const REQUEST_DATA = 'REQUEST_DATA';



// WEBPACK FOOTER //
// ./app/src/App/actionTypes.js